export default __webpack_public_path__ + "static/media/english-to-greek-screenshot-03.d37653de.png";